import { METHOD } from 'services/method'

export const API_DAILY_DEALS = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/daily-deal',
        method: METHOD.GET,
    },
    URL_IMAGE_DAILY_DEALS: {
        api: '/v1/dashboard-admin/main-page/home-page/daily-deal/storage-url/attachment',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/daily-deal',
        method: METHOD.PUT,
    },
}
